import { defineMessages } from 'react-intl';

export const scope = 'app.components.Icons';

export default defineMessages({
  warningIconDescription: {
    id: `${scope}.warningIconDescription`,
    defaultMessage: 'Warning icon',
  },
});
